module.exports = __webpack_public_path__ + "static/img/registrationEn.799fd80b.png";